import axios from 'axios';
import llStorage from './llStorage';
import {logout} from './utils/auth'; // Assuming auth is a module that handles authentication

const apiBaseUrl =
  process.env.REACT_APP_BACKEND_URL ||
  process.env.LL_BACKEND_URL ||
  'http://localhost:5000/api';

const axiosInstance = axios.create({
  baseURL: apiBaseUrl,
});

// Request interceptor to add token from storage to every request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = llStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle token refresh on 401 responses
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      // Retrieve refresh token from proper storage.
      const refreshToken = llStorage.getItem('refreshToken');
      
      if (refreshToken) {
        try {
          const response = await axios.post(`${apiBaseUrl}/users/refresh-token`, { refreshToken });
          const { token: newToken, refreshToken: newRefreshToken } = response.data;
          // Update tokens in storage based on where they originally came from.
          
          llStorage.setItem('token', newToken);
          llStorage.setItem('refreshToken', newRefreshToken);
          
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return axiosInstance(originalRequest);
        } catch (err) {
          console.error('Token refresh failed:', err);
          // Optionally force logout here
          logout(); // Assuming this function handles logout
        }
      }
      else
      {
        console.error('No refresh token available, logging out');
        logout(); // Assuming this function handles logout  
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;